<template>
  <div>
    <a-row :gutter="16">
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <div class="wrapper-form" >
          <a-form-model
            ref="ruleForm"
            :model="form"
            :rules="rules"
            class="steps-content m-flex1"
          >
            <a-form-model-item label="SPPD Detail" prop="sppd_detail">
              <a-select
                showSearch
                class="m-width-full"
                placeholder="Please Select"
                v-model="form.sppd_detail"
              >
                <a-select-option
                  v-for="item in calculatedSppd"
                  :key="item.id_sppd_dtl"
                >
                  <!-- <div class="select-option">
                    <div v-if="!getScreen">
                      <h4>{{ item.item_nm }}</h4>
                      <small>|</small>
                      <small>{{ item.kode_anggaran }}</small>
                    </div>
                    <h4 v-else>{{ item.item_nm }}</h4>
                    <small>{{
                      formatRupiah(item.saldo_anggaran)
                        .replace("Rp", "")
                        .replace(",00", "")
                    }}</small>
                  </div> -->
                  <div class="elipsdiv">
                    <div class="elipsdiv-mouseover-label1" >
                      {{ item.item_nm }}
                      <small>|</small>
                      <small>{{ item.kode_anggaran }}</small>
                    </div>
                    <div class="elipsdiv-mouseover-label2">
                        <b style="float: right">{{
                            formatCurrency("IDR",parseFloat(item.saldo_anggaran)).replace(",00", "")
                          }}
                        </b>
                    </div>
                  </div>
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item label="Item Name" prop="item_nm">
              <a-input v-model="form.item_nm"></a-input>
            </a-form-model-item>
            <a-form-model-item prop="value">
              <span slot="label">Value ({{ information.mata_uang }})</span>
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                v-model="form.value"
              ></a-input-number>
            </a-form-model-item>
            <small>Converted to IDR: {{ formatRupiah(converted) }}</small>
          </a-form-model>

          <div class="wrapper-form__action">
            <a-button type="primary" @click="handleNew" icon="plus">Add</a-button>
          </div>
        </div>
      </a-col>
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <div class="wrapper">
          <div class="wrapper-output" style="width:100%">
            <div class="detail">
              <div class="detail-header">
                UM PD/S Detail
              </div>
              <div class="detail-content">
                <a-table
                  :rowKey="(record, index) => {return index;}"
                  :columns="columns"
                  :dataSource="detail_list"
                  :pagination="pagination"
                  size="small"
                  class="table"
                  :scroll="{ x: 400 }"
                  bordered
                >
                  <div slot="deskripsi" slot-scope="index, item">
                    <h4 class="margin-remove">{{ item.itemName }}</h4>
                    <small
                      >{{ item.anggaranNm ? item.anggaranNm : item.anggarannm }} |
                      {{ item.kodeAnggaran }}</small
                    >
                  </div>
                  <div slot="value" slot-scope="index, item">
                    <span>{{ information.mata_uang + " " + item.value }}</span>
                  </div>
                  <div slot="no" slot-scope="record, item, index">
                    <span>{{ index + 1 }}</span>
                  </div>
                  <template slot="operation" slot-scope="index, item">
                    <a-button-group size="small" v-if="item.value">
                      <a-button type="primary" @click="handleEdit(item)">
                        <a-icon type="edit" />
                      </a-button>
                      <a-button type="danger" @click="handleRemove(item)">
                        <a-icon type="close" />
                      </a-button>
                    </a-button-group>
                  </template>
                </a-table>
              </div>
            </div>
            <div class="total-price">
              <span class="label-price">Grand Total</span>
              <span class="value-price">{{
                formatCurrencyCode(this.information.mata_uang, grandTotal)
              }}</span>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>

    <a-modal
      title="Form Changes"
      :visible="modalEdit"
      :maskClosable="false"
      @cancel="handleCancel"
      @ok="handleEditConfirm"
    >
      <a-form-model ref="ruleFormEdit" :model="formEdit" :rules="rules">
        <a-form-model-item label="No SPPD/S" prop="sppd_detail">
          <a-select
            showSearch
            class="select-between"
            placeholder="Please Select"
            v-model="formEdit.sppd_detail"
          >
            <a-select-option
              v-for="item in calculatedSppd"
              :key="item.id_sppd_dtl"
            >
              <div class="select-option">
                <div v-if="!getScreen">
                  <h4>{{ item.item_nm }}</h4>
                  <small>|</small>
                  <small>{{ item.kode_anggaran }}</small>
                </div>
                <h4 v-else>{{ item.item_nm }}</h4>
                <small>{{
                  formatRupiah(item.saldo_anggaran)
                    .replace("Rp", "")
                    .replace(",00", "")
                }}</small>
              </div>
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="Item Name" prop="item_nm">
          <a-input v-model="formEdit.item_nm"></a-input>
        </a-form-model-item>
        <a-form-model-item prop="value">
          <span slot="label">Value ({{ information.mata_uang }})</span>
          <a-input-number
            type="number"
            class="m-width-full m-text-align-right"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
            v-model="formEdit.value"
          ></a-input-number>
        </a-form-model-item>
        <small>Converted to IDR: {{ formatRupiah(converted) }}</small>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "detail",
  props: {
    information: {},
    detailList: {},
    list_item: Array,
    mode: String,
  },
  mixins: [CurrencyFormat],
  data() {
    const columns = [
      {
        title: "No",
        dataIndex: "no",
        key: "no",
        width: 60,
        align: "center",
        scopedSlots: { customRender: "no" },
        sorter: (a, b) => a.no - b.no,
        fixed: "left",
      },
      {
        title: "Item Name",
        dataIndex: "itemName",
        key: "itemName",
        width: 250,
        scopedSlots: { customRender: "deskripsi" },
      },
      {
        title: "Value",
        dataIndex: "value",
        key: "value",
        align: "right",
        width: 180,
        scopedSlots: { customRender: "value" },
      },
      {
        title: "Action",
        dataIndex: "operation",
        scopedSlots: { customRender: "operation" },
        width: 110,
        fixed: "right",
      },
    ];
    return {
      item_list: [],
      form: {
        sppd_detail: "",
        value: 0,
        item_nm: "",
      },
      formEdit: {
        sppd_detail: "",
        value: 0,
        item_nm: "",
      },
      columns,
      detail_list: [],
      rules: {
        sppd_detail: [
          {
            required: true,
            message: "Please Select SPPD Detail",
            trigger: "change",
          },
        ],
        item_nm: [
          {
            required: true,
            message: "Item Name Cannot Be Empty",
            trigger: "blur",
          },
        ],
        value: [
          {
            required: true,
            trigger: "change",
          },
        ],
      },
      selectedSppd: {},
      selectedEdit: {},
      pagination: {
        onChange: (page) => {},
        pageSize: 4,
        size: "small",
      },
      modalEdit: false,
    };
  },
  computed: {
    ...mapGetters(["getAuth", "getScreen"]),
    converted() {
      const converted = this.modalEdit
        ? this.formEdit.value * this.information.kurs
        : this.form.value * this.information.kurs;
      return converted;
    },
    grandTotal() {
      let total = 0;
      this.detail_list.forEach((obj) => {
        total = total + parseInt(obj.value);
      });

      return total;
    },
    calculatedSppd: {
      get: function() {
        return this.item_list;
      },

      set: function(item) {
        return item;
      },
    },
  },
  methods: {
    async fetchDetailList() {
      await this.$store
        .dispatch("getItemDetailSppd", {
          data: this.getAuth,
          id_sppd: this.information.id_sppd,
        })
        .then((result) => {
          this.list_Item = result.list_nama_item;
        });
    },
    isOverValue(params) {
      return new Promise((resolve, reject) => {
        this.calculatedSppd.filter((obj) => {
          if (obj.id_sppd_dtl === params.idSppdDtl) {
            const calc =
              parseInt(obj.saldo_anggaran) + this.selectedEdit.converted;

            if (params.converted > calc) {
              reject("over-price");
              return;
            } else {
              obj.saldo_anggaran = calc - params.converted;
              resolve(calc);
            }
          }
        });
      });
    },
    reCalculated(params) {
      this.calculatedSppd.filter((obj) => {
        if (obj.id_sppd_dtl === params.idSppdDtl) {
          obj.saldo_anggaran = obj.saldo_anggaran - params.converted;
        }
      });
    },
    handleNew() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) {
          return;
        }

        this.selectedSppd = this.calculatedSppd.filter(
          (obj) =>
            obj.id_sppd_dtl
              .toLowerCase()
              .indexOf(this.form.sppd_detail.toLowerCase()) >= 0
        );

        let data = {
          no: this.detail_list.length + 1,
          anggaranNm: this.selectedSppd[0].item_nm,
          kodeAnggaran: this.selectedSppd[0].kode_anggaran,
          idSppdDtl: this.selectedSppd[0].id_sppd_dtl,
          itemName: this.form.item_nm,
          value: this.form.value,
          converted: this.converted,
        };

        if (this.converted > this.selectedSppd[0].saldo_anggaran) {
          this.displayMessage("over-kredit");
        } else if (this.form.value == 0) {
          this.displayMessage("grather0");
        } else {
          if (this.detail_list.length == 0) {
            // langsung push
            this.reCalculated(data);
            this.detail_list.push(data);
            this.$refs.ruleForm.resetFields();
            this.selectedSppd = {};
            this.form.value = 0;
          } else {
            // validasi terlebih dahulu
            let validasi = [];
            this.detail_list.forEach((obj) => {
              if (
                obj.idSppdDtl == this.selectedSppd[0].id_sppd_dtl &&
                obj.itemName == this.form.item_nm
              ) {
                validasi = obj;
              }
            });

            if (validasi.length == 0) {
              this.reCalculated(data);
              this.detail_list.push(data);
              this.$refs.ruleForm.resetFields();
              this.selectedSppd = {};
              this.form.value = 0;
            } else {
              this.displayMessage("form-duplicate");
            }
          }
        }
      });
    },
    handleRemove(item) {
      this.confirmMessageValue("confirm-delete", item);
    },
    handleEdit(item) {
      this.selectedEdit = item;
      if (this.selectedEdit.converted == undefined) {
        const calc = parseInt(this.information.kurs) * parseInt(item.value);
        this.selectedEdit.converted = calc;
      }

      this.formEdit = {
        item_nm: item.itemName,
        sppd_detail: item.idSppdDtl,
        value: item.value,
      };
      this.modalEdit = true;
    },
    handleEditConfirm() {
      this.$refs.ruleFormEdit.validate((valid) => {
        if (!valid) {
          return;
        }

        this.selectedSppd = this.calculatedSppd.filter(
          (obj) =>
            obj.id_sppd_dtl
              .toLowerCase()
              .indexOf(this.formEdit.sppd_detail.toLowerCase()) >= 0
        );

        let data = {
          no: this.selectedEdit.no,
          anggaranNm: this.selectedSppd[0].item_nm,
          kodeAnggaran: this.selectedSppd[0].kode_anggaran,
          idSppdDtl: this.formEdit.sppd_detail,
          itemName: this.formEdit.item_nm,
          value: this.formEdit.value,
          converted: this.converted,
        };

        if (this.formEdit.value == 0) {
          this.displayMessage("grather0");
        } else {
          this.isOverValue(data)
            .then((res) => {
              let validasi = [];
              this.detail_list.forEach((obj) => {
                if (
                  obj.idSppdDtl == this.selectedSppd[0].id_sppd_dtl &&
                  obj.itemName == this.formEdit.item_nm
                ) {
                  validasi.push(obj);
                }
              });

              if (validasi.length == 0) {
                // edit data baru
                if (this.selectedEdit.idSppdDtl !== this.formEdit.sppd_detail) {
                  // no Sppd berbeda dengan existing data
                  this.calculatedSppd.filter((obj) => {
                    if (obj.id_sppd_dtl === this.selectedEdit.idSppdDtl) {
                      obj.saldo_anggaran =
                        obj.saldo_anggaran + this.selectedEdit.converted;
                    } else if (obj.id_sppd_dtl === data.idSppdDtl) {
                      obj.saldo_anggaran = obj.saldo_anggaran - data.converted;
                    }
                  });
                  this.detail_list.filter((obj) => {
                    if (obj.itemName == this.formEdit.item_nm) {
                      obj.no = data.no;
                      obj.anggaranNm = this.selectedSppd[0].item_nm;
                      obj.kodeAnggaran = this.selectedSppd[0].kode_anggaran;
                      obj.idSppdDtl = this.selectedSppd[0].id_sppd_dtl;
                      obj.itemName = data.itemName;
                      obj.value = data.value;
                      obj.converted = data.converted;
                      this.displayMessage("success-edit");
                      this.modalEdit = false;
                    }
                  });
                } else {
                  // no sppd sama, data beda
                  this.detail_list.filter((obj) => {
                    if (obj.itemName == this.selectedEdit.itemName && 
                        obj.idSppdDtl == this.selectedEdit.idSppdDtl) {
                      obj.no = data.no;
                      obj.anggaranNm = this.selectedSppd[0].item_nm;
                      obj.kodeAnggaran = this.selectedSppd[0].kode_anggaran;
                      obj.idSppdDtl = this.selectedSppd[0].id_sppd_dtl;
                      obj.itemName = data.itemName;
                      obj.value = data.value;
                      obj.converted = data.converted;
                      this.displayMessage("success-edit");
                      this.modalEdit = false;
                    }
                  });
                }
              } else {
                if (
                  validasi[0].itemName == this.formEdit.item_nm &&
                  validasi[0].idSppdDtl == this.formEdit.sppd_detail
                ) {
                  if (
                    this.selectedEdit.itemName == this.formEdit.item_nm &&
                    this.selectedEdit.idSppdDtl == this.formEdit.sppd_detail
                  ) {
                    this.detail_list.filter((obj) => {
                      if (obj.itemName == this.selectedEdit.itemName) {
                        obj.no = data.no;
                        obj.anggaranNm = this.selectedSppd[0].item_nm;
                        obj.kodeAnggaran = this.selectedSppd[0].kode_anggaran;
                        obj.idSppdDtl = this.selectedSppd[0].id_sppd_dtl;
                        obj.itemName = data.itemName;
                        obj.value = data.value;
                        obj.converted = data.converted;
                        this.displayMessage("success-edit");
                        this.modalEdit = false;
                      }
                    });
                  } else {
                    this.displayMessage("form-duplicate");
                  }
                } else {
                  this.detail_list.filter((obj) => {
                    if (obj.itemName == this.selectedEdit.itemName) {
                      obj.no = data.no;
                      obj.anggaranNm = this.selectedSppd[0].item_nm;
                      obj.kodeAnggaran = this.selectedSppd[0].kode_anggaran;
                      obj.idSppdDtl = this.selectedSppd[0].id_sppd_dtl;
                      obj.itemName = data.itemName;
                      obj.value = data.value;
                      obj.converted = data.converted;
                      this.displayMessage("success-edit");
                      this.modalEdit = false;
                    }
                  });
                }
              }
            })
            .catch((err) => {
              console.log(err);
              this.displayMessage("over-kredit");
            });
        }
      });
    },
    handleCancel() {
      this.modalEdit = false;
    },
    remove(item) {
      const { idSppdDtl, itemName } = item;
      let result = this.detail_list.filter((obj) => {
        return obj.idSppdDtl !== idSppdDtl || obj.itemName !== itemName;
      });
      const returnValue = parseInt(item.value) * this.information.kurs;
      this.calculatedSppd.filter((obj) => {
        if (obj.id_sppd_dtl === item.idSppdDtl) {
          obj.saldo_anggaran =
            parseInt(obj.saldo_anggaran) + parseInt(returnValue);
        }
      });

      this.detail_list = result;
      this.displayMessage("success-del");
    },
    handleRef() {
      // this.$refs.ruleForm.validate((valid) => {
      //   if (!valid) {
      //     return;
      //   }
          let data = {
            detail: this.detail_list ? this.detail_list : {}, 
            grandTotal: this.grandTotal
          }
          Event.$emit("handleChildValue", data);
      // });
    },
  },
  mounted() {
    this.item_list = this.list_item;
    Event.$on("confirmMessageDelete", this.remove);
    if (this.detailList.length > 0 && this.mode == "Create") {
      this.calculatedSppd.forEach((obj) => {
        this.detailList.forEach((item) => {
          if (obj.id_sppd_dtl == item.idSppdDtl) {
            const calc = obj.saldo_anggaran - item.converted;
            obj.saldo_anggaran = calc;
          }
        });
      });
      this.detail_list = this.detailList;
    } else {
      this.detail_list = this.detailList;
    }
  },
  beforeDestroy() {
    Event.$off("confirmMessageDelete", this.remove);
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;

  &-form {
    flex: 1;
    padding: @padding;
    display: flex;
    flex-direction: column;
    gap: @padding;

    form {
      flex: 1;
    }

    &__action {
      padding: @padding;
      box-shadow: -2px 0 10px 0 rgba(0, 0, 0, 0.05);
    }
  }
  &-output {
    background-color: darken(white, 1);
    width: 600px;
    padding: @padding;
    display: flex;
    gap: @padding;
    flex-direction: column;

    .detail {
      flex: 1;
      position: relative;
      overflow: hidden;
      background-color: white;
      display: flex;
      flex-direction: column;

      &-header {
        padding: @padding;
        margin-bottom: @margin;
        box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
        font-weight: 600;
        font-size: 1rem;
      }

      &-content {
        flex: 1;
        padding: @padding;
      }
    }

    .total-price {
      min-height: 60px;
      background-color: darken(white, 5);
      padding: @padding;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      flex-direction: column;
      line-height: 1.2;

      .label-price {
        font-size: 1rem;
        font-weight: 600;
      }

      .value-price {
        font-size: 1.5rem;
        font-weight: bold;
      }
    }
  }
}
</style>

<style lang="less">
.select {
  &-option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    > div {
      display: flex;
      gap: @padding / 2;
    }
  }
  &-between {
    .ant-select-selection {
      width: 100%;
      display: flex;
      justify-content: space-between;
      float:unset!important;
      &__rendered {
        flex: 1;
        padding-right: @padding;
        display: flex;
        float:unset!important;
      }
      &-selected-value {
        flex: 1;
        float:unset!important;
      }
    }
  }
  .ant-select-selection-selected-value{
    width:100%!important;
  }
}
</style>
